import usePosOrder from './usePosOrder';

export default usePosOrder;
